import { PayloadAction } from '@reduxjs/toolkit';
import { FavouriteState } from '../slice';

const removeFavouriteProductsReducer = (state: FavouriteState, action: PayloadAction<string>) => {
  state.products = state.products.filter((product) => product.sku !== action.payload);
};

export default removeFavouriteProductsReducer;
